var d = /* @__PURE__ */ ((u) => (u[u.Arkhangelsk = 29] = "Arkhangelsk", u[u.Barnaul = 22] = "Barnaul", u[u.Chelyabinsk = 74] = "Chelyabinsk", u[u.Fontanka = 78] = "Fontanka", u[u.Irkutsk = 38] = "Irkutsk", u[u.Izhevsk = 18] = "Izhevsk", u[u.Kazan = 16] = "Kazan", u[u.Kemerovo = 42] = "Kemerovo", u[u.KemerovoRugion = 142] = "KemerovoRugion", u[u.KhantyMansiysk = 86] = "KhantyMansiysk", u[u.Kirov = 43] = "Kirov", u[u.KrasnodarRugion = 23] = "KrasnodarRugion", u[u.Krasnoyarsk = 24] = "Krasnoyarsk", u[u.KrasnoyarskRugion = 124] = "KrasnoyarskRugion", u[u.Kurgan = 45] = "Kurgan", u[u.Lipetsk = 48] = "Lipetsk", u[u.Magnitogorsk = 182028] = "Magnitogorsk", u[u.Mosk = 1077] = "Mosk", u[u.Murmansk = 51] = "Murmansk", u[u.NizhnyNovgorod = 52] = "NizhnyNovgorod", u[u.NovosibirskRugion = 154] = "NovosibirskRugion", u[u.Nsk = 54] = "Nsk", u[u.Omsk = 55] = "Omsk", u[u.OmskRugion = 155] = "OmskRugion", u[u.Orenburg = 56] = "Orenburg", u[u.Perm = 59] = "Perm", u[u.Pskov = 60] = "Pskov", u[u.Rostov = 61] = "Rostov", u[u.Ryazan = 62] = "Ryazan", u[u.SaintPetersburg = 47] = "SaintPetersburg", u[u.Samara = 63] = "Samara", u[u.Saratov = 64] = "Saratov", u[u.Sochi = 93] = "Sochi", u[u.Stavropol = 26] = "Stavropol", u[u.Sterlitamak = 114160] = "Sterlitamak", u[u.Tambov = 68] = "Tambov", u[u.Tolyatty = 142982] = "Tolyatty", u[u.Tomsk = 70] = "Tomsk", u[u.TomskRugion = 170] = "TomskRugion", u[u.Tula = 71] = "Tula", u[u.Tyumen = 72] = "Tyumen", u[u.Ufa = 2] = "Ufa", u[u.Ulyanovsk = 73] = "Ulyanovsk", u[u.VelikiiNovgorod = 53] = "VelikiiNovgorod", u[u.Vladivostok = 25] = "Vladivostok", u[u.Volgograd = 34] = "Volgograd", u[u.Vologda = 35] = "Vologda", u[u.Voronezh = 36] = "Voronezh", u[u.Yakutsk = 14] = "Yakutsk", u[u.YamaloNenetsAutonomousArea = 89] = "YamaloNenetsAutonomousArea", u[u.Yaroslavl = 76] = "Yaroslavl", u[u.Yekaterinburg = 66] = "Yekaterinburg", u[u.YekaterinburgRugion = 166] = "YekaterinburgRugion", u[u.Chita = 75] = "Chita", u[u.DoubleNsk = 1154] = "DoubleNsk", u))(d || {});
const a = {
  [73]: {
    geoIds: [73],
    domain: "173.ru",
    city: "\u0423\u043B\u044C\u044F\u043D\u043E\u0432\u0441\u043A"
  },
  [1154]: {
    geoIds: [1154],
    domain: "nsk54.online",
    city: "\u041D\u043E\u0432\u043E\u0441\u0438\u0431\u0438\u0440\u0441\u043A"
  },
  [2]: {
    geoIds: [2],
    domain: "ufa1.ru",
    city: "\u0423\u0444\u0430"
  },
  [114160]: {
    geoIds: [2],
    domain: "sterlitamak1.ru",
    city: "\u0421\u0442\u0435\u0440\u043B\u0438\u0442\u0430\u043C\u0430\u043A"
  },
  [14]: {
    geoIds: [14],
    domain: "14.ru",
    city: "\u042F\u043A\u0443\u0442\u0441\u043A"
  },
  [16]: {
    geoIds: [16],
    domain: "116.ru",
    city: "\u041A\u0430\u0437\u0430\u043D\u044C"
  },
  [18]: {
    geoIds: [18],
    domain: "proizhevsk.ru",
    city: "\u0418\u0436\u0435\u0432\u0441\u043A"
  },
  [22]: {
    geoIds: [22],
    domain: "ngs22.ru",
    city: "\u0411\u0430\u0440\u043D\u0430\u0443\u043B"
  },
  [1077]: {
    geoIds: [77],
    domain: "msk1.ru",
    city: "\u041C\u043E\u0441\u043A\u0432\u0430"
  },
  [23]: {
    geoIds: [23],
    domain: "93.ru",
    city: "\u041A\u0440\u0430\u0441\u043D\u043E\u0434\u0430\u0440"
  },
  [93]: {
    geoIds: [23],
    domain: "sochi1.ru",
    city: "\u0421\u043E\u0447\u0438"
  },
  [124]: {
    geoIds: [24],
    domain: "kbs.ru",
    city: "\u041A\u0440\u0430\u0441\u043D\u043E\u044F\u0440\u0441\u043A"
  },
  [24]: {
    geoIds: [24],
    domain: "ngs24.ru",
    city: "\u041A\u0440\u0430\u0441\u043D\u043E\u044F\u0440\u0441\u043A"
  },
  [26]: {
    geoIds: [26],
    domain: "26.ru",
    city: "\u0421\u0442\u0430\u0432\u0440\u043E\u043F\u043E\u043B\u044C"
  },
  [29]: {
    geoIds: [29],
    domain: "29.ru",
    city: "\u0410\u0440\u0445\u0430\u043D\u0433\u0435\u043B\u044C\u0441\u043A"
  },
  [25]: {
    geoIds: [25],
    domain: "vladivostok1.ru",
    city: "\u0412\u043B\u0430\u0434\u0438\u0432\u043E\u0441\u0442\u043E\u043A"
  },
  [38]: {
    geoIds: [38],
    domain: "ircity.ru",
    city: "\u0418\u0440\u043A\u0443\u0442\u0441\u043A"
  },
  [35]: {
    geoIds: [35],
    domain: "35.ru",
    city: "\u0412\u043E\u043B\u043E\u0433\u0434\u0430"
  },
  [34]: {
    geoIds: [34],
    domain: "v1.ru",
    city: "\u0412\u043E\u043B\u0433\u043E\u0433\u0440\u0430\u0434"
  },
  [36]: {
    geoIds: [36],
    domain: "voronezh1.ru",
    city: "\u0412\u043E\u0440\u043E\u043D\u0435\u0436"
  },
  [42]: {
    geoIds: [42],
    domain: "ngs42.ru",
    city: "\u041A\u0435\u043C\u0435\u0440\u043E\u0432\u043E"
  },
  [142]: {
    geoIds: [42],
    domain: "42.ru",
    city: "\u041A\u0435\u043C\u0435\u0440\u043E\u0432\u043E"
  },
  [45]: {
    geoIds: [45],
    domain: "45.ru",
    city: "\u041A\u0443\u0440\u0433\u0430\u043D"
  },
  [43]: {
    geoIds: [43],
    domain: "43.ru",
    city: "\u041A\u0438\u0440\u043E\u0432"
  },
  [48]: {
    geoIds: [48],
    domain: "48.ru",
    city: "\u041B\u0438\u043F\u0435\u0446\u043A"
  },
  [51]: {
    geoIds: [51],
    domain: "51.ru",
    city: "\u041C\u0443\u0440\u043C\u0430\u043D\u0441\u043A"
  },
  [52]: {
    geoIds: [52],
    domain: "nn.ru",
    city: "\u041D\u0438\u0436\u043D\u0438\u0439 \u041D\u043E\u0432\u0433\u043E\u0440\u043E\u0434"
  },
  [53]: {
    geoIds: [53],
    domain: "53.ru",
    city: "\u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u041D\u043E\u0432\u0433\u043E\u0440\u043E\u0434"
  },
  [54]: {
    geoIds: [54],
    domain: "ngs.ru",
    city: "\u041D\u043E\u0432\u043E\u0441\u0438\u0431\u0438\u0440\u0441\u043A"
  },
  [154]: {
    geoIds: [54],
    domain: "154.ru",
    city: "\u041D\u043E\u0432\u043E\u0441\u0438\u0431\u0438\u0440\u0441\u043A"
  },
  [55]: {
    geoIds: [55],
    domain: "ngs55.ru",
    city: "\u041E\u043C\u0441\u043A"
  },
  [155]: {
    geoIds: [55],
    domain: "omsk1.ru",
    city: "\u041E\u043C\u0441\u043A"
  },
  [56]: {
    geoIds: [56],
    domain: "56.ru",
    city: "\u041E\u0440\u0435\u043D\u0431\u0443\u0440\u0433"
  },
  [59]: {
    geoIds: [59],
    domain: "59.ru",
    city: "\u041F\u0435\u0440\u043C\u044C"
  },
  [60]: {
    geoIds: [60],
    domain: "60.ru",
    city: "\u041F\u0441\u043A\u043E\u0432"
  },
  [61]: {
    geoIds: [61],
    domain: "161.ru",
    city: "\u0420\u043E\u0441\u0442\u043E\u0432"
  },
  [62]: {
    geoIds: [62],
    domain: "62.ru",
    city: "\u0420\u044F\u0437\u0430\u043D\u044C"
  },
  [63]: {
    geoIds: [63],
    domain: "63.ru",
    city: "\u0421\u0430\u043C\u0430\u0440\u0430"
  },
  [142982]: {
    geoIds: [63],
    domain: "tolyatty.ru",
    city: "\u0422\u043E\u043B\u044C\u044F\u0442\u0442\u0438"
  },
  [64]: {
    geoIds: [64],
    domain: "164.ru",
    city: "\u0421\u0430\u0440\u0430\u0442\u043E\u0432"
  },
  [66]: {
    geoIds: [66],
    domain: "e1.ru",
    city: "\u0415\u043A\u0430\u0442\u0435\u0440\u0438\u043D\u0431\u0443\u0440\u0433"
  },
  [166]: {
    geoIds: [66],
    domain: "ekat.ru",
    city: "\u0415\u043A\u0430\u0442\u0435\u0440\u0438\u043D\u0431\u0443\u0440\u0433"
  },
  [68]: {
    geoIds: [68],
    domain: "68.ru",
    city: "\u0422\u0430\u043C\u0431\u043E\u0432"
  },
  [70]: {
    geoIds: [70],
    domain: "ngs70.ru",
    city: "\u0422\u043E\u043C\u0441\u043A"
  },
  [170]: {
    geoIds: [70],
    domain: "70.ru",
    city: "\u0422\u043E\u043C\u0441\u043A"
  },
  [71]: {
    geoIds: [71],
    domain: "71.ru",
    city: "\u0422\u0443\u043B\u0430"
  },
  [72]: {
    geoIds: [72],
    domain: "72.ru",
    city: "\u0422\u044E\u043C\u0435\u043D\u044C"
  },
  [74]: {
    geoIds: [74],
    domain: "74.ru",
    city: "\u0427\u0435\u043B\u044F\u0431\u0438\u043D\u0441\u043A"
  },
  [182028]: {
    geoIds: [74],
    domain: "mgorsk.ru",
    city: "\u041C\u0430\u0433\u043D\u0438\u0442\u043E\u0433\u043E\u0440\u0441\u043A"
  },
  [76]: {
    geoIds: [76],
    domain: "76.ru",
    city: "\u042F\u0440\u043E\u0441\u043B\u0430\u0432\u043B\u044C"
  },
  [47]: {
    geoIds: [47, 78],
    domain: "178.ru",
    city: "\u0421\u0430\u043D\u043A\u0442-\u041F\u0435\u0442\u0435\u0440\u0431\u0443\u0440\u0433"
  },
  [78]: {
    geoIds: [47, 78],
    domain: "fontanka.ru",
    city: "\u0421\u0430\u043D\u043A\u0442-\u041F\u0435\u0442\u0435\u0440\u0431\u0443\u0440\u0433"
  },
  [86]: {
    geoIds: [86],
    domain: "86.ru",
    city: "\u0425\u0430\u043D\u0442\u044B-\u041C\u0430\u043D\u0441\u0438\u0439\u0441\u043A"
  },
  [89]: {
    geoIds: [89],
    domain: "89.ru",
    city: "\u042F\u043C\u0430\u043B\u043E-\u041D\u0435\u043D\u0435\u0446\u043A\u0438\u0439 \u0410\u041E"
  },
  [75]: {
    geoIds: [75],
    domain: "chita.ru",
    city: "\u0427\u0438\u0442\u0430"
  }
}, r = (u) => a[u].geoIds, t = (u) => a[u].domain, m = (u) => a[u].city, y = (u, o) => a[u].geoIds.includes(o), i = (u, o) => u === o;
export {
  d as Regions,
  m as getCityByRegionId,
  t as getDomainByRegionId,
  r as getGeoIdsByRegionId,
  y as isRegionIdMatchedWithGeoId,
  i as isSameRegion
};
